import React, { useState } from 'react';
import InlineSpinner from '../Visualeffects/InlineSpinner';

export default function ContactPage() {
  const [name, setName] = useState('');
  const [mail, setMail] = useState('');
  const [msg, setMsg] = useState('');
  const [feedback, setFeedback] = useState(null);
  const [isSending, setIsSending] = useState(false);

  const handleSend = async (e) => {
    e.preventDefault();
    setFeedback(null);
    setIsSending(true);
    try {
      const res = await fetch('https://api.numsolve.org/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name, email: mail, message: msg }),
      });

      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.error) {
        setFeedback({
          type: 'error',
          text: `Senden fehlgeschlagen: ${data.error || res.statusText}`,
        });
        return;
      }

      setFeedback({ type: 'success', text: 'Email successfully sent.' });
      setName('');
      setMail('');
      setMsg('');
    } catch (error) {
      console.error('Failed to send message', error);
      setFeedback({ type: 'error', text: `Network error: ${error.message}` });
    } finally {
      setIsSending(false);
    }
  };

  return (
    <section className="relative mx-auto w-full max-w-4xl px-6 pb-24 pt-28 text-white lg:px-16">
      <div className="pointer-events-none absolute inset-x-0 top-10 -z-10 h-64 rounded-full bg-gradient-to-r from-[#8b5cf6]/25 via-transparent to-[#ec4899]/25 blur-3xl" />
      <header className="mb-10 space-y-4">
        <p className="text-sm uppercase tracking-[0.35em] text-white/60">Say hello</p>
        <h1 className="text-4xl font-semibold leading-tight md:text-5xl">Contact</h1>
        <p className="max-w-2xl text-lg text-white/70">
          Send us a message for feature requests, collaboration ideas or support. We usually reply within a few business days.
        </p>
      </header>
      <div className="rounded-3xl border border-white/10 bg-white/90 p-8 text-slate-900 shadow-[0_35px_65px_-45px_rgba(76,29,149,0.8)] backdrop-blur">
        <form onSubmit={handleSend} className="space-y-5">
          <div>
            <label className="block text-sm font-semibold text-slate-700">Name</label>
            <input
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-slate-900 shadow-sm focus:border-fuchsia-400 focus:outline-none focus:ring-2 focus:ring-fuchsia-200"
              placeholder="John Doe"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700">Email</label>
            <input
              type="email"
              value={mail}
              onChange={(e) => setMail(e.target.value)}
              className="mt-2 w-full rounded-2xl border border-slate-200 bg-white px-4 py-2.5 text-slate-900 shadow-sm focus:border-fuchsia-400 focus:outline-none focus:ring-2 focus:ring-fuchsia-200"
              placeholder="john@example.com"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-slate-700">Message</label>
            <textarea
              value={msg}
              onChange={(e) => setMsg(e.target.value)}
              rows={6}
              className="mt-2 w-full min-h-[11rem] rounded-2xl border border-slate-200 bg-white px-4 py-3 text-slate-900 shadow-sm focus:border-fuchsia-400 focus:outline-none focus:ring-2 focus:ring-fuchsia-200"
              placeholder="How can we help?"
              required
            />
          </div>
          <div className="flex flex-col gap-3 pt-2 sm:flex-row sm:items-center sm:justify-end">
            <p className="text-xs text-slate-500 sm:mr-auto">
              By sending this message you consent to us storing your contact details in order to respond.
            </p>
            <button
              type="submit"
              disabled={isSending}
              className="flex items-center justify-center gap-2 rounded-full bg-gradient-to-r from-[#8b5cf6] to-[#ec4899] px-6 py-2.5 font-semibold text-white shadow-lg transition hover:shadow-[0_20px_45px_-30px_rgba(236,72,153,0.7)] disabled:opacity-60 disabled:shadow-none"
            >
              {isSending && <InlineSpinner className="h-5 w-5 text-white" />}
              {isSending ? 'Sending' : 'Send message'}
            </button>
          </div>
        </form>
        {feedback && (
          <div
            className={`mt-6 rounded-2xl border px-5 py-4 text-sm font-medium ${
              feedback.type === 'success'
                ? 'border-emerald-200 bg-emerald-50 text-emerald-700'
                : 'border-rose-200 bg-rose-50 text-rose-700'
            }`}
          >
            {feedback.text}
          </div>
        )}
      </div>
    </section>
  );
}
